import styled from 'styled-components'
import { MarginsProps, PaddingsProps, getMarginPadding } from '../helpers/styleHelpers'

type StartCenterEnd = 'flex-start' | 'center' | 'flex-end'

export type FlexProps = Partial<MarginsProps & PaddingsProps> & {
  column?: boolean
  align?: StartCenterEnd | 'stretch' | 'baseline'
  alignSelf?: StartCenterEnd | 'stretch' | 'baseline'
  justify?: StartCenterEnd | 'space-between' | 'space-around' | 'space-evenly'
  fullWidth?: boolean
  flex?: number | string
  children?: React.ReactNode
}

const Flex = styled.div<FlexProps>`
  ${getMarginPadding};
  width: ${props => (props.fullWidth ? '100%' : 'auto')};
  display: flex;
  flex: ${props => props.flex};
  flex-direction: ${props => (props.column ? 'column' : 'row')};
  align-items: ${props => props.align || 'flex-start'};
  align-self: ${props => props.alignSelf || undefined};
  justify-content: ${props => props.justify};
`

export { Flex }
